'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LIKE = exports.LIKE = 'LIKE';
var EQ = exports.EQ = '=';
var NE = exports.NE = '!=';
var GT = exports.GT = '>';
var GE = exports.GE = '>=';
var LT = exports.LT = '<';
var LE = exports.LE = '<=';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-table2-filter/lib/src/comparison.js
// module id = 79
// module chunks = 0